export default {
  LOADING_DONE(state) {
    state.loading = false; // eslint-disable-line
  },

  SET_STATE_TRANSITION(state, payload) {
    state.isInTransition = payload; // eslint-disable-line
  },

  SET_STATE_LOCK_SCROLLING(state, payload) {
    state.scrollIsLocked = payload; // eslint-disable-line
  },

  SET_STATE_IS_IN_PAGE(state, payload) {
    state.isInPage = payload; // eslint-disable-line
  },

  SET_CURRENT_INDEX(state, payload) {
    state.currentIndex = payload; // eslint-disable-line
    state.currentPage = state.content.find(el => el.index === payload); // eslint-disable-line
  },
};
